import { Helmet } from 'react-helmet';
import Header from '../../../../Components/Header'
import MainContent from './MainContent'
const Brand = () => {
  return (
		<div className="d-flex flex-column" style={{ minHeight: "99.7vh" }}>
			<Helmet>
				<title>Brand List</title>
			</Helmet>
			<Header />
			<MainContent />
		</div>
	);
}
export default Brand